import { isMissingFunction } from './orderProgress';

/**
 * Poprawka v13 (24.10, D): stan „Zapisu na żywo” kanałów zleceń — jedno wywołanie RPC `order_writes_info` (t76, < 100 ms
 * w bazie) zamiast edge `publish-order action:info` per zlecenie (13–24 s w logach dev 24.10: edge woła auth/v1/user +
 * ~9 zapytań po kolei). Bez funkcji w bazie (prod przed t76) → edge, jak dotąd. Każda ścieżka z limitem czasu: zamiast
 * wiecznego „sprawdzany…” błąd z „Spróbuj ponownie”.
 */
export const WRITES_INFO_TIMEOUT_MS = 8000;
let rpcMissing = false;
export const _resetWritesInfo = () => { rpcMissing = false; };

export function withTimeout(promise, ms, label = 'stan zapisu') {
  let t;
  const timeout = new Promise((_, reject) => { t = setTimeout(() => reject(new Error(`${label}: brak odpowiedzi w ${Math.round(ms / 1000)} s`)), ms); });
  return Promise.race([Promise.resolve(promise), timeout]).finally(() => clearTimeout(t));
}

/** Zwraca listę stanów w kolejności `orderIds`; rzuca, gdy któregoś nie da się ustalić (błąd/odmowa/limit czasu). */
export async function fetchWritesInfo(orderIds, { rpc, edgeInfo, timeoutMs = WRITES_INFO_TIMEOUT_MS }) {
  const ids = (orderIds || []).filter(Boolean);
  if (!ids.length) return [];
  if (!rpcMissing && rpc) {
    const res = await withTimeout(rpc(ids), timeoutMs);
    if (!res?.error && Array.isArray(res?.data?.items)) {
      const byId = new Map(res.data.items.map(i => [String(i.order_id), i]));
      return ids.map(id => {
        const it = byId.get(String(id));
        if (!it) throw new Error('brak stanu zapisu zlecenia');
        if (it.error) throw new Error(it.error);
        return it;
      });
    }
    if (res?.error && isMissingFunction(res.error)) rpcMissing = true;
    else if (res?.error) throw new Error(res.error.message || 'błąd odczytu stanu zapisu');
    else if (res?.data?.error) throw new Error(res.data.error);
  }
  return Promise.all(ids.map(id => withTimeout(edgeInfo(id), timeoutMs)));
}
